import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-product-navbar',
  imports: [],
  templateUrl: './product-navbar.html',
  styleUrl: './product-navbar.scss',
})
export class ProductNavbar {
  title = input<string>()
  scrollSpecs = output()
  scrollMain = output()
  shouldShowSpecs = input<boolean>(false)

  goToSpecs() {
    this.scrollSpecs.emit()
  }

  goToMain() {
    this.scrollMain.emit()
  }

}
